/* tslint:disable */
/* eslint-disable */
/**
 * Easy Invoices API v1
 * The Easy Invoices API for Shopify embedded app - automatic invoice generation and export functionality
 *
 * The version of the OpenAPI document: 1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */



/**
 * live: reporting. stale: no sample for 45 s. no_agent: known only from Hetzner (sidecar not running).
 * @export
 * @enum {string}
 */

export enum OpsNodeStatus {
    Live = 'live',
    Stale = 'stale',
    NoAgent = 'no_agent'
}



